import { useContext, useEffect, useState } from "react";
import { Button, Spin, Popconfirm, message } from "antd";
import { Link } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import { UserContext } from "../../context/userContext";
import { getProductsDetails } from "../../services/productsDetails/productsDetails";
import { patchUserCart } from "../../services/user/user";
import { formatNumber } from "../../helper/fomartNum";
import { priceNew } from "../../helper/priceNew";
import "./Cart.scss";

function Cart() {
  const { currentUser, setCurrentUser } = useContext(UserContext);
  const [cartProducts, setCartProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    const fetchCartProducts = async () => {
      if (!currentUser?.cart || currentUser.cart.length === 0) {
        setCartProducts([]);
        return;
      }
      setLoading(true);
      try {
        const results = await Promise.all(
          currentUser.cart.map((id) => getProductsDetails(id))
        );
        setCartProducts(results.map((r) => r[0]));
      } catch (err) {
        console.log(err);
      }
      setLoading(false);
    };
    fetchCartProducts();
  }, [currentUser]);

  const handleRemove = async (productId) => {
    try {
      const newCart = currentUser.cart.filter((id) => id !== productId);
      await patchUserCart(currentUser.id, newCart);
      setCurrentUser({ ...currentUser, cart: newCart });

      messageApi.open({
        type: "success",
        content: "Đã xóa sản phẩm khỏi giỏ hàng",
      });
    } catch (err) {
      messageApi.open({
        type: "error",
        content: "Xóa thất bại",
      });
    }
  };

  const totalPrice = cartProducts.reduce(
    (acc, p) => acc + priceNew(p.price_old, p.sales),
    0
  );

  return (
    <>
      <main>
        {contextHolder}
        <div className="cart-page">
          <h2 className="cart-title">Giỏ hàng</h2>

          {loading ? (
            <div className="cart-loading">
              <Spin />
            </div>
          ) : cartProducts.length === 0 ? (
            <div className="cart-none">Giỏ hàng trống</div>
          ) : (
            <>
              {cartProducts.map((p) => (
                <div key={p.id} className="cart-item">
                  <Link to={`/products/${p.id}`}>
                    <img src={p.thumbnail1} alt={p.title} />
                  </Link>

                  <div className="cart-info">
                    <div className="cart-name">{p.title}</div>

                    <div className="cart-price">
                      <del className="price-old">
                        {formatNumber(p.price_old)}đ
                      </del>
                      <div className="price-new">
                        {formatNumber(priceNew(p.price_old, p.sales))}đ
                      </div>
                    </div>

                    <div className="cart-size">{p.size}</div>

                    <Popconfirm
                      title="Bạn có chắc muốn xóa?"
                      onConfirm={() => handleRemove(p.id)}
                    >
                      <RiDeleteBin6Line className="cart-icon-delete" />
                    </Popconfirm>
                  </div>
                </div>
              ))}

              <div className="cart-money">
                Tổng tiền: {formatNumber(totalPrice)}đ
              </div>

              <div className="cart-sub">
                Phí vận chuyển sẽ được tính khi bạn thanh toán
              </div>

              <div className="cart-btn">
                <Link to="/checkoutCart">
                  <Button className="cart-btn-payment">Thanh toán</Button>
                </Link>

                <Link to="/">
                  <Button className="cart-btn-watch">Tiếp tục mua</Button>
                </Link>
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
}

export default Cart;
